import React, { useEffect, useState } from "react";
import * as CronofyElements from "cronofy-elements";

const SlotPickerWrapper = ({ options }) => {
    const [element, setElement] = useState(null);
    const targetId = "cronofy-slot-picker";

    useEffect(() => {
        if (!element && options?.element_token) {
            const combinedOptions = { ...options, target_id: targetId };
            setElement(
                CronofyElements.SlotPicker(combinedOptions)
            );
        }
    }, [options?.element_token, element]);

    return <div id={targetId} />;
};

export default SlotPickerWrapper;